<sb-searchable-list-section
	[editableInStoryblok]="_editable"
	[emptyListContent]="emptyListContent()"
	[emptyListTitle]="emptyListTitle()"
	[hideFilter]="hideFilter()"
	[hidePriceFilter]="true"
	[persuadeCards]="hotels()"
	[title]="title()"
	[useStoryblokCards]="false"
/>
